/**
 * API Configuration
 *
 * Handles API URL based on environment:
 * - Development: Uses Vite proxy (/api) -> localhost:5000
 * - Production/Staging: Uses full API URL from environment variable
 */

const getApiUrl = () => {
  // In production/staging, use the environment variable
  // In development, use relative URL (Vite proxy handles it)
  const apiUrl = import.meta.env.VITE_API_URL

  if (apiUrl) {
    // Remove trailing slash if present
    return apiUrl.replace(/\/$/, '')
  }

  // In development, return empty string to use relative URLs
  // Vite's proxy will forward /api requests to localhost:5000
  return ''
}

export const API_URL = getApiUrl()

/**
 * Helper function to create full API endpoint URL
 * @param {string} endpoint - API endpoint (e.g., '/auth/login')
 * @returns {string} Full API URL
 */
export const getApiEndpoint = (endpoint) => {
  // Ensure endpoint starts with /api
  const normalizedEndpoint = endpoint.startsWith('/api')
    ? endpoint
    : `/api${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`

  // If API_URL is empty, use relative path (same-domain via CloudFront)
  if (!API_URL) {
    return normalizedEndpoint
  }

  // Otherwise use full URL (for development with external API)
  return `${API_URL}${normalizedEndpoint}`
}

export default {
  API_URL,
  getApiEndpoint,
}
